/* eslint-disable react/display-name */
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import { SelectV2 } from '@smartsheet/lodestar-core';
import React, { useCallback, useState } from 'react';
import { Workflow } from '../../services/api/WorkflowService';
import { getWorkspaceWorkflows } from '../../services/api/WorkspaceService/WorkspaceService';

enum HasLoadedStatus {
  LOADING = 'Loading Workflows...',
  FOUND = 'Select Workflow',
  NOT_FOUND = 'No Workflows Found',
}

interface InputWorkflowProps extends EntityId {
  value: string;
  onChange: (value: string | number) => void;
}

export const InputWorkflow = React.memo(
  ({ id, onChange, value }: InputWorkflowProps) => {
    const [options, setOptions] = useState<
      Array<{ label: string; value: string }>
    >([]);
    const [placeholder, setPlaceholder] = useState<HasLoadedStatus>(
      HasLoadedStatus.LOADING
    );

    const setWorkflows = (
      workflows: Array<{ label: string; value: string }>
    ) => {
      setOptions(workflows);
      if (workflows.length) {
        setPlaceholder(HasLoadedStatus.FOUND);
      } else {
        setPlaceholder(HasLoadedStatus.NOT_FOUND);
      }
    };

    React.useEffect(() => {
      const workspaceId = JSON.parse(
        sessionStorage.getItem('converse:active_workspace') || ''
      );
      const workflows: Array<{
        label: string;
        value: string;
      }> = [];

      if (workspaceId === '') {
        setWorkflows(workflows);
      } else {
        getWorkspaceWorkflows(workspaceId)
          .then(response => {
            let valueMatchUUID;
            let valueMatchIntent;

            response.data.forEach((workflow: Workflow) => {
              workflows.push({
                label: workflow.intent,
                value: workflow.objectUUID,
              });

              if (workflow.objectUUID === value) {
                valueMatchUUID = value;
              }
              if (workflow.intent === value) {
                valueMatchIntent = workflow.objectUUID;
              }
            });

            const revisedValue: string =
              valueMatchUUID || valueMatchIntent || value;

            if (revisedValue !== value) {
              onChange(revisedValue);
            } else if (!(valueMatchIntent || valueMatchUUID) && value) {
              workflows.unshift({
                label: '[Workflow Deleted]',
                value,
              });
            }
            setWorkflows(workflows);
          })
          .catch();
      }
    }, [onChange, value]);

    const selectedValue =
      options.find(option => value === option.value) || null;

    const onChangeHandler = useCallback(
      newValue => {
        onChange(newValue?.value || '');
      },
      [onChange]
    );

    return (
      (<SelectV2
        id={id}
        locale="en"
        options={options}
        selectedOption={selectedValue}
        getOptionKey={option => option.value as string}
        onChange={onChangeHandler}
        placeholder={placeholder} />)
    );
  }
);
